// Generated by scripts/generate-public-surface.ts. Do not edit.

import type {
  CountryValidator,
  ParsedPersonId,
} from "../../types";

import { createValidator } from "#stdnum-runtime";

const egn: CountryValidator<"BG", ParsedPersonId> =
  createValidator("bg.egn", 21);

export default egn;
export const compact = egn.compact;
export const format = egn.format;
export const validate = egn.validate;
export const generate = (): string =>
  egn.generate?.() ??
  (() => {
    throw new Error(
      "Validator bg.egn cannot generate values",
    );
  })();
export const parse = egn.parse;
